import InputField from "@/components/common/fields/InputField"
import fieldStyles from "@/styles/Fields.module.scss"
import CustomFieldFormEmojiPicker from "@/components/common/CustomFieldFormEmojiPicker"
import CustomFieldQueueSelector from "@/components/common/CustomFieldQueueSelector"
import { useMemo } from "react"

export default function CustomFieldOption({
  icon,
  index,
  remove,
  handleChange,
  value,
  name,
  type,
  queuesOptions,
  valueMetaName,
  valueMeta,
}) {

  const isQueueSelector = useMemo(() => {
    return type === 'queueselect'
  }, [type])

  const defaultQueue = useMemo(() => {
    if (isQueueSelector && valueMeta) {
      return valueMeta
    }
    return queuesOptions[0].value
  }, [valueMeta, queuesOptions])

  return ( 
    <div className={fieldStyles.cfEmojiField}>
      <InputField
        label="Title"
        name={`options.${index}.value`}
        onChange={handleChange}
        value={value}
      />
      {!isQueueSelector && (
        <CustomFieldFormEmojiPicker name={name} icon={icon} anchor="right" />
      )}
      {isQueueSelector && (
        <CustomFieldQueueSelector
          options={queuesOptions}
          name={valueMetaName}
          index={index}
          defaultValue={defaultQueue}
        />
      )}
      
      <img
        className={fieldStyles.cfDeleteIcon}
        src="/icons/delete.svg"
        alt="Delete Option"
        width={20}
        onClick={() => remove(index)}
      />
    </div>
  )
}
